import React from "react"
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete'; //https://material-ui.com/components/autocomplete/
import CompanyUniverse from "../data/companies.json"

export default class TickerDropDown extends React.Component 
  {
    state = {
      selectedCompany: this.getDefault()
    }
    selectionChanged = (event,newValue) =>  {
        this.setState({selectedCompany:newValue})
        const newTicker=(newValue == null) ? "" : newValue.ticker
        this.props.onSelectedTickerChanged(newTicker) //pass it up to container
    }
    getDefault() {
      return CompanyUniverse.find(company=>company.ticker===this.props.defaultTicker)
    }
   
    render() {
    //  console.log('ticker render')
        return (
            <Autocomplete
        id="tickerSelect"
        value={this.state.selectedCompany}

        options={CompanyUniverse}
        getOptionLabel={(option) => `${option.ticker} - ${option.name}`}
        style={{ width: 300 }}
        onChange={this.selectionChanged}
        renderInput={(params) => <TextField {...params} label="Ticker" variant="outlined" helperText={this.props.helperText}/>}
        />
        )
    }
  

  }